import { render, staticRenderFns } from "./appeal.vue?vue&type=template&id=45fb7ed2&scoped=true"
import script from "./appeal.vue?vue&type=script&lang=js"
export * from "./appeal.vue?vue&type=script&lang=js"
import style0 from "./appeal.vue?vue&type=style&index=0&id=45fb7ed2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb7ed2",
  null
  
)

export default component.exports